export function useActivityFrequencies() {
  const { t } = useI18n({ useScope: 'global' })

  return Object.values(Frequency)
    .filter(freq => freq != Frequency.Flexible)
    .map(freq => ({
      value: freq,
      name: t(`activities.frequencies.${freq}`),
    }))
}
